var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report-section"},[(_vm.title)?_c('div',{staticClass:"section-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),(_vm.children && _vm.children.length)?_c('div',{staticClass:"section-body"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }